<template>
  <component
    :is="popoverComponent"
    v-if="popoverComponent"
    v-bind="popoverProps"
  />
</template>

<script setup lang="ts">
import { useWidgetPopovers } from '@widgets/messenger/compositions/useWidgetPopovers'
import { popoverComponentMap } from '@widgets/messenger/types/popover'
import { computed } from '@/composition/vue/compositionApi'

const { openedPopover } = useWidgetPopovers()

const popoverComponent = computed(() => {
  if (!openedPopover.value) {
    return undefined
  }
  return popoverComponentMap[openedPopover.value?.name]
})

const popoverProps = computed(() => {
  if (!openedPopover.value) {
    return {}
  }
  return openedPopover.value?.payloadGetter()
})
</script>
